import { createSlice } from "@reduxjs/toolkit";
import { PVI_CHECKLIST } from "../../incpection.com/data/pvi_data";

// Generate flat key → value state
const generateInitialChecklistState = () => {
  const checklist = {};

  PVI_CHECKLIST.forEach((item) => {
    checklist[item.key] = null; // default "unchecked"
  });

  return checklist;
};

const initialState = generateInitialChecklistState(); // flat state

const pvi_checkListSlice = createSlice({
  name: "pvi_list",
  initialState,
  reducers: {
    toggleCheck: (state, action) => {
      const key = action.payload;

      if (state[key] === undefined) return;

      // cycle: null → true → false → null
      state[key] =
        state[key] === null ? true : state[key] === true ? false : null;
    },

    setPviInitial: (state, action) => {
      // replace all keys with new values
      Object.assign(state, action.payload);
    },

    resetPviChecklist: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = null;
      });
    },
  },
});

export const { toggleCheck, resetPviChecklist, setPviInitial } =
  pvi_checkListSlice.actions;

export default pvi_checkListSlice.reducer;